import { _query } from '../utils/query.js'

export function emailValidation (emailValue) {
  $.ajax({
		url: '/api/email/validate-email',
		data: {
			email: emailValue,
		},
		type: 'GET',
		timeout: 5000,
		dataType: 'json',
	}).done((json) => {
		if (json.status) {
		}
	})
	.fail((xhr, status, errorThrown) => {
		// hideLoadingModal()
	})
}

